var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex h-100" },
    [
      !_vm.loading && _vm.game
        ? _c(
            "v-card",
            {
              staticClass: "d-flex flex-column h-100 flex-grow-1 justify-start",
              class: { "rounded-r-0": _vm.xgMap },
              attrs: {
                "min-height": "350",
                elevation: "0",
                outlined: "",
                height: "100%",
              },
            },
            [
              _c(
                "v-card-title",
                {
                  staticClass:
                    "py-1 px-4 white--text d-flex align-center justify-space-between",
                  class: _vm.$vuetify.theme.dark ? "black" : "primary",
                  staticStyle: { "flex-wrap": "nowrap" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-center",
                      staticStyle: { flex: "1 1 auto", "min-width": "0" },
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { color: "white", medium: "" },
                        },
                        [_vm._v("dvr")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                        },
                        [_vm._v(_vm._s(_vm.$t("dashboards.lastGame")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "pl-0 pr-0",
                      staticStyle: { "flex-shrink": "0", "min-width": "auto" },
                      attrs: {
                        text: "",
                        small: "",
                        to: `/game/${_vm.game.gameId}`,
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "white--text text-decoration-underline font-weight-bold mr-1",
                        },
                        [_vm._v(_vm._s(_vm.$t("general.seeAll")))]
                      ),
                      _vm._v(" "),
                      _c("v-icon", { attrs: { small: "", color: "white" } }, [
                        _vm._v("keyboard_arrow_right"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.game
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-center justify-center px-4 pt-3 pb-2",
                    },
                    [
                      _vm.game.leagueId && !_vm.game.leagueImgError
                        ? _c("img", {
                            staticClass: "mr-2",
                            attrs: {
                              src:
                                "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/" +
                                _vm.game.leagueId +
                                ".png",
                              height: "18",
                              contain: "",
                            },
                            on: {
                              error: function ($event) {
                                return _vm.onImageLoadFailure($event, "league")
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "body-2 primary--text font-weight-bold mr-2",
                        },
                        [_vm._v(_vm._s(_vm.game.leagueName))]
                      ),
                      _vm._v(" "),
                      _vm.game.leagueId
                        ? _c("span", { staticClass: "mr-2 primary--text" }, [
                            _vm._v("-"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "caption primary--text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getLocalMatchDate(
                              _vm.game.matchDate,
                              "DD/MM/YYYY"
                            )
                          )
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-center justify-center px-4 py-3" },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-center mr-6" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            top: "",
                            color: "lightSecondary lighten-4",
                            "max-width": "300",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                            },
                                          },
                                          "div",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "d-flex align-center justify-center",
                                            staticStyle: {
                                              "text-decoration": "none",
                                            },
                                            attrs: {
                                              to: `/team/${_vm.game.homeTeamId}`,
                                            },
                                          },
                                          [
                                            _c("v-img", {
                                              attrs: {
                                                src: _vm.game.homeTeamImgError
                                                  ? "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png"
                                                  : "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                                    _vm.game.homeTeamId +
                                                    ".png",
                                                height: _vm.$vuetify.breakpoint
                                                  .smAndDown
                                                  ? "35"
                                                  : "45",
                                                width: _vm.$vuetify.breakpoint
                                                  .smAndDown
                                                  ? "35"
                                                  : "45",
                                                contain: "",
                                              },
                                              on: {
                                                error: function ($event) {
                                                  return _vm.onImgError(
                                                    $event,
                                                    "home"
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3472178716
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", { staticClass: "black--text body-1" }, [
                            _vm._v(_vm._s(_vm.game.homeTeamName)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "d-flex align-center text-h4 font-weight-bold primary--text",
                      staticStyle: {
                        "text-decoration": "none",
                        "min-width": "80px",
                        "justify-content": "center",
                      },
                      attrs: { to: `/game/${_vm.game.gameId}` },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.game.homeTeamScore))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "mx-2" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.game.awayTeamScore))]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-center ml-4" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            top: "",
                            color: "lightSecondary lighten-4",
                            "max-width": "300",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                            },
                                          },
                                          "div",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "d-flex align-center justify-center",
                                            staticStyle: {
                                              "text-decoration": "none",
                                            },
                                            attrs: {
                                              to: `/team/${_vm.game.awayTeamId}`,
                                            },
                                          },
                                          [
                                            _c("v-img", {
                                              attrs: {
                                                src: _vm.game.awayTeamImgError
                                                  ? "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png"
                                                  : "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                                    _vm.game.awayTeamId +
                                                    ".png",
                                                height: _vm.$vuetify.breakpoint
                                                  .smAndDown
                                                  ? "35"
                                                  : "45",
                                                width: _vm.$vuetify.breakpoint
                                                  .smAndDown
                                                  ? "35"
                                                  : "45",
                                                contain: "",
                                              },
                                              on: {
                                                error: function ($event) {
                                                  return _vm.onImgError(
                                                    $event,
                                                    "away"
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3360290652
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", { staticClass: "black--text body-1" }, [
                            _vm._v(_vm._s(_vm.game.awayTeamName)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "my-1" }),
              _vm._v(" "),
              _vm.loadingStats
                ? _c(
                    "div",
                    { staticClass: "d-flex justify-center" },
                    [
                      _vm.loadingStats
                        ? _c("v-progress-circular", {
                            attrs: {
                              size: 35,
                              color: "secondary",
                              indeterminate: "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.homeStats && _vm.awayStats && !_vm.loadingStats
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        { staticClass: "metric-row py-2 px-4 px-md-6 px-lg-8" },
                        [
                          _c("div", { staticClass: "metric-side" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium metric-value metric-value-container",
                                class: _vm.getValueColorClass(
                                  "xG",
                                  _vm.homeStats.xG,
                                  _vm.awayStats.xG,
                                  "home"
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumberInput(_vm.homeStats.xG)
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "primary--text body-1 font-weight-bold metric-label",
                            },
                            [_vm._v(_vm._s(_vm.$t("game.stats.xG")))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "metric-side" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium metric-value metric-value-container",
                                class: _vm.getValueColorClass(
                                  "xG",
                                  _vm.homeStats.xG,
                                  _vm.awayStats.xG,
                                  "away"
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumberInput(_vm.awayStats.xG)
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "my-1" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "metric-row py-2 px-4 px-md-6 px-lg-8" },
                        [
                          _c("div", { staticClass: "metric-side" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium metric-value metric-value-container",
                                class: _vm.getValueColorClass(
                                  "possession",
                                  _vm.homeStats.possession,
                                  _vm.awayStats.possession,
                                  "home"
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.homeStats.possession
                                      ? _vm.formatNumberInput(
                                          _vm.homeStats.possession
                                        ) + "%"
                                      : "-"
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "primary--text body-1 font-weight-bold metric-label",
                            },
                            [_vm._v(_vm._s(_vm.$t("game.stats.possession")))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "metric-side" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium metric-value metric-value-container",
                                class: _vm.getValueColorClass(
                                  "possession",
                                  _vm.homeStats.possession,
                                  _vm.awayStats.possession,
                                  "away"
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.awayStats.possession
                                      ? _vm.formatNumberInput(
                                          _vm.awayStats.possession
                                        ) + "%"
                                      : "-"
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "my-1" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "metric-row py-2 px-4 px-md-6 px-lg-8" },
                        [
                          _c("div", { staticClass: "metric-side" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium metric-value metric-value-container",
                                class: _vm.getValueColorClass(
                                  "shots",
                                  _vm.homeStats.shots,
                                  _vm.awayStats.shots,
                                  "home"
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumberInput(_vm.homeStats.shots)
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "primary--text body-1 font-weight-bold metric-label",
                            },
                            [_vm._v(_vm._s(_vm.$t("game.stats.shots")))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "metric-side" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium metric-value metric-value-container",
                                class: _vm.getValueColorClass(
                                  "shots",
                                  _vm.homeStats.shots,
                                  _vm.awayStats.shots,
                                  "away"
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumberInput(_vm.awayStats.shots)
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "my-1" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "metric-row py-2 px-4 px-md-6 px-lg-8" },
                        [
                          _c("div", { staticClass: "metric-side" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium metric-value metric-value-container",
                                class: _vm.getValueColorClass(
                                  "ppda",
                                  _vm.homeStats.ppda,
                                  _vm.awayStats.ppda,
                                  "home"
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumberInput(_vm.homeStats.ppda)
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "primary--text body-1 font-weight-bold metric-label",
                            },
                            [_vm._v(_vm._s(_vm.$t("game.stats.ppda")))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "metric-side" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium metric-value metric-value-container",
                                class: _vm.getValueColorClass(
                                  "ppda",
                                  _vm.homeStats.ppda,
                                  _vm.awayStats.ppda,
                                  "away"
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumberInput(_vm.awayStats.ppda)
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-divider", { staticClass: "my-1" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "metric-row py-2 px-4 px-md-6 px-lg-8" },
                        [
                          _c("div", { staticClass: "metric-side" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium metric-value metric-value-container",
                                class: _vm.getValueColorClass(
                                  "expectedPoints",
                                  _vm.homeStats.expectedPoints,
                                  _vm.awayStats.expectedPoints,
                                  "home"
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumberInput(
                                      _vm.homeStats.expectedPoints
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "primary--text body-1 font-weight-bold metric-label",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("game.stats.expectedPoints"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "metric-side" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-medium metric-value metric-value-container",
                                class: _vm.getValueColorClass(
                                  "expectedPoints",
                                  _vm.homeStats.expectedPoints,
                                  _vm.awayStats.expectedPoints,
                                  "away"
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumberInput(
                                      _vm.awayStats.expectedPoints
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.loadingStats && (!_vm.homeStats || !_vm.awayStats)
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column align-center justify-center",
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          style: {
                            "font-size": _vm.$vuetify.breakpoint.mdAndUp
                              ? "80px"
                              : "60px",
                          },
                          attrs: { color: "primary lighten-5" },
                        },
                        [_vm._v("blur_on")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "primary--text lighten--text-2 body-1" },
                        [_vm._v(_vm._s(_vm.$t("general.dataAvailable")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "v-card",
            {
              staticClass:
                "d-flex flex-grow-1 justify-center align-center py-8 px-12",
            },
            [
              _c("v-progress-circular", {
                attrs: { size: 75, color: "secondary", indeterminate: "" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.xgMap
        ? _c(
            "v-card",
            {
              ref: "chart",
              staticClass: "text-center d-flex align-center rounded-l-0",
              attrs: { id: "chart", elevation: "2" },
            },
            [
              _vm.game &&
              _vm.xgMap &&
              _vm.size != 0 &&
              _vm.game != null &&
              _vm.shots &&
              _vm.shots.length > 0
                ? _c("XGChart", {
                    key: _vm.xgMapKey,
                    staticClass: "mb-n2",
                    attrs: {
                      id: `${_vm.game.gameId}`,
                      size: _vm.size,
                      game: _vm.game,
                      shots: _vm.filteredShots,
                      homeTeamName: _vm.game.homeTeamName,
                      awayTeamName: _vm.game.awayTeamName,
                      circlesAndBoxes: _vm.checkboxCircles,
                      language: _vm.currentUserLanguage,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && !_vm.game
        ? _c(
            "v-card",
            {
              staticClass: "d-flex flex-column flex-grow-1",
              attrs: { elevation: "0", outlined: "" },
            },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "py-2 white--text d-flex align-center",
                  class: _vm.$vuetify.theme.dark ? "black" : "primary",
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { color: "white", medium: "" },
                    },
                    [_vm._v("dvr")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "white--text body-font body-1 font-weight-bold text-uppercase",
                    },
                    [_vm._v(_vm._s(_vm.$t("dashboards.lastGame")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-center align-center flex-column px-3 py-4 mb-13 text-center flex-grow-1",
                },
                [
                  _c(
                    "v-icon",
                    {
                      style: {
                        "font-size": _vm.$vuetify.breakpoint.mdAndUp
                          ? "80px"
                          : "60px",
                      },
                      attrs: { color: "primary lighten-5" },
                    },
                    [_vm._v("event_busy")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "primary--text lighten--text-2 body-1" },
                    [_vm._v(_vm._s(_vm.$t("dashboards.placeholderNextGame")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }